<template>
<div>
    <patent-official-deadline-log-report></patent-official-deadline-log-report>
</div>
</template>

  
<script>
export default {}
</script>
